import { Controller } from "@hotwired/stimulus"

/*
  Use this controller on document move select elements to handle form submission
  with proper target_type determination.

  Example:
  <form data-controller="document-move">
    <select name="target_claim_id" data-action="change->document-move#submit">
      <option value="123">Claim #123</option>
      <option value="discard">Discard</option>
      <option value="new_claim">+ Create new claim</option>
    </select>
    <input type="hidden" name="target_type" data-document-move-target="targetType">
  </form>
*/
export default class extends Controller {
  static targets = ["targetType"]

  submit(event) {
    const value = event.target.value

    if (value === "discard") {
      this.targetTypeTarget.value = "discard"
    } else if (value === "new_claim") {
      this.targetTypeTarget.value = "new_claim"
    } else {
      this.targetTypeTarget.value = "claim"
    }

    this.element.requestSubmit()
  }
}
